import { useTranslation } from 'react-i18next';
import { IFilterOption, FilterTypes, IOption } from '../../../../base';
import { UserStatus } from '../../../../common';

export const useTableFilters = (): IFilterOption[] => {
    const { t } = useTranslation();

    const userStatusOptions = (): Array<IOption> => [
        {
            key: UserStatus.Active,
            label: t(`statuses.${UserStatus.Active}`),
            value: UserStatus.Active,
        },
        {
            key: UserStatus.Deactivated,
            label: t(`statuses.${UserStatus.Deactivated}`),
            value: UserStatus.Deactivated,
        },
    ];

    return [
        {
            id: 'status',
            label: t('teamMembersTable.status'),
            type: FilterTypes.options,
            optionValues: userStatusOptions(),
        },
    ];
};
